import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shared-component-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'hmf-display-block',
  },
})
export class LoadingSpinnerComponent {}
